import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminClaimRelaunchPlansRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/claim_relaunch_plans',
  validateSearch: z.object({
    page: zodPage,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import(
    'pages/admin/ClaimRelaunchPlans/AdminClaimRelaunchPlansPage/AdminClaimRelaunchPlansPage'
  ).then((d) => d.Route)
);
